import './css/App.css';
import React, { lazy, Suspense, useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import Footer from './componentes/Footer';
import HeaderMensaje from './componentes/HeaderMensaje';
import HomeSaaS from './Pages/HomeSaaS';
import HomeLanding from './Pages/HomeLanding';
import AOS from 'aos';
import 'aos/dist/aos.css';

const GestionApp = lazy(() => import('./gestion/GestionModule'));

function WebsiteLayout() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="app-wrapper d-flex flex-column min-vh-100">
      <HeaderMensaje />
      <div className="main-content flex-grow-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route
        path="/gestion/*"
        element={
          <Suspense fallback={<main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>Cargando Gestión…</main>}>
            <GestionApp />
          </Suspense>
        }
      />
      <Route element={<WebsiteLayout />}>
        <Route path="/" element={<HomeSaaS />} />
        <Route path="/bot-imagy" element={<HomeLanding />} />
      </Route>
    </Routes>
  );
}

export default App;
